import ogrn from './ogrn.jpg';
import ogryul from './ogryul.jpg';
import uchyot from './uchyot.jpg';

export const taxesData = [
  {
    image: ogryul,
    description: "Свидетельство о государтвенной регистрации юридического лица от 14 декабря 2008г.",
    file: 'ogryul.pdf',
  },
  {
    image: uchyot,
    description: "Свидетельство о постановке на учет российской организации в налоговом органе по месту нахождения на территории Российской Федерации",
    file: 'uchyot.pdf',
  },
  {
    image: ogrn,
    description: "Свидетельство о внесении записи в Единый государственный реестр юридических лиц о юридическом лице, зарегистрированном до 5 апреля 2010г.",
    file: 'ogrn.pdf',
  }
];